export default {"src":"/_next/static/media/user-pin.2cdd4678.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};